const { createContext } = require("react");

export const VishcorpSettingsContext = createContext();
